/**
 * Media API client for heavy operations that are split into separate endpoints
 * to reduce the main TRPC bundle size
 */

export class MediaAPI {
  private baseUrl: string;

  constructor(baseUrl: string = '') {
    this.baseUrl = baseUrl;
  }

  private async makeRequest(endpoint: string, data: any) {
    const response = await fetch(`${this.baseUrl}/api/media/${endpoint}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`Media API error: ${response.statusText}`);
    }

    return response.json();
  }

  // Compress operations
  async compressImage(input: any) {
    return this.makeRequest('compress', {
      router: 'compress',
      procedure: 'image',
      input,
    });
  }

  async compressVideo(input: any) {
    return this.makeRequest('compress', {
      router: 'compress', 
      procedure: 'video',
      input,
    });
  }

  async compressAudio(input: any) {
    return this.makeRequest('compress', {
      router: 'compress',
      procedure: 'audio', 
      input,
    });
  }

  // Convert operations
  async convertImage(input: any) {
    return this.makeRequest('convert', {
      router: 'convert',
      procedure: 'image',
      input,
    });
  }

  async convertVideo(input: any) {
    return this.makeRequest('convert', {
      router: 'convert',
      procedure: 'video',
      input,
    });
  }

  async convertAudio(input: any) {
    return this.makeRequest('convert', {
      router: 'convert',
      procedure: 'audio',
      input,
    });
  }

  // OCR operations
  async extractText(input: any) {
    return this.makeRequest('ocr', {
      router: 'ocr',
      procedure: 'extractText',
      input,
    });
  }

  async extractTextFromImage(input: any) {
    return this.makeRequest('ocr', {
      router: 'ocr',
      procedure: 'extractTextFromImage',
      input,
    });
  }
}

// Export a default instance
export const mediaAPI = new MediaAPI();
